export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: Date; output: Date; }
  AWSTimestamp: { input: number; output: number; }
};

export const Action = {
  add: 'ADD',
  remove: 'REMOVE'
} as const;

export type Action = typeof Action[keyof typeof Action];
export type ActivateUserInput = {
  activateUserItem: ActivateUserItem;
  auth0OrganizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type ActivateUserItem = {
  auth0UserId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ActiveUsers = {
  auth0UserIds: Array<Scalars['ID']['input']>;
};

export type AddOrRemoveGroupInput = {
  action: Action;
  activeUsers?: InputMaybe<ActiveUsers>;
  groupId: Scalars['String']['input'];
  invitedUsers?: InputMaybe<InvitedUsers>;
};

export type AdminData = {
  __typename?: 'AdminData';
  activeUserCount: Scalars['Int']['output'];
  expiredUserCount: Scalars['Int']['output'];
  invitedUserCount: Scalars['Int']['output'];
  servicesData?: Maybe<Array<Maybe<ServiceData>>>;
};

export type AllUsers = {
  __typename?: 'AllUsers';
  adminGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  auth0UserId?: Maybe<Scalars['ID']['output']>;
  authority: Authority;
  createdAt: Scalars['AWSTimestamp']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  groups: Array<Group>;
  licenseData?: Maybe<Array<Maybe<LicenseData>>>;
  name?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
};

export type Authority = {
  __typename?: 'Authority';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  usedQuantity?: Maybe<Scalars['Int']['output']>;
};

export const AuthorityName = {
  contractAdministrator: 'contractAdministrator',
  groupAdministrator: 'groupAdministrator',
  viewer: 'viewer'
} as const;

export type AuthorityName = typeof AuthorityName[keyof typeof AuthorityName];
export type CommonSettings = {
  __typename?: 'CommonSettings';
  licenses: Array<LicenseValue>;
  options: Array<OptionValue>;
};

export type CommonSettingsInput = {
  licenses: Array<LicenseValueInput>;
  options: Array<OptionValueInput>;
};

export const ContractType = {
  cancel: 'cancel',
  new: 'new',
  restart: 'restart',
  stop: 'stop'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
export type CreateGroupByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateGroupInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGroupOutput = Group | UserError;

export type CreateLicensesByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  licenseInputs: Array<LicenseInput>;
};

export type CreateOptionsByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  createCount: Scalars['Int']['input'];
  masterId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOptionsInput = {
  createCount: Scalars['Int']['input'];
  masterId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationInput = {
  contractNumber: Scalars['String']['input'];
  customerContactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  specteeProStatus: PlanStatus;
  specteeScrStatus: PlanStatus;
};

export type CreatePlanByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  masterId: Scalars['String']['input'];
  status: PlanStatus;
};

export type DeleteAllUsersInput = {
  activeUsers?: InputMaybe<ActiveUsers>;
  invitedUsers?: InputMaybe<InvitedUsers>;
};

export type DeleteAllUsersResponse = {
  __typename?: 'DeleteAllUsersResponse';
  error?: Maybe<Scalars['String']['output']>;
  failedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statusCode: Message;
};

export type DeleteGroupsByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  groupIds: Array<Scalars['String']['input']>;
};

export type DeleteGroupsInput = {
  groupIds: Array<Scalars['String']['input']>;
};

export type DeleteGroupsResponse = {
  __typename?: 'DeleteGroupsResponse';
  error?: Maybe<Scalars['String']['output']>;
  statusCode: Message;
};

export type DeleteInvitationsByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
};

export type DeleteInvitationsInput = {
  emails: Array<Scalars['String']['input']>;
};

export type DeleteOrganizationResponse = {
  __typename?: 'DeleteOrganizationResponse';
  error?: Maybe<Scalars['String']['output']>;
  statusCode: Message;
};

export type DeleteUsersByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  auth0UserIds: Array<Scalars['ID']['input']>;
};

export type DeleteUsersInput = {
  auth0UserIds: Array<Scalars['ID']['input']>;
};

export type FilterInput = {
  match?: InputMaybe<Scalars['String']['input']>;
  notMatch?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  auth0OrganizationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Inquiry = {
  __typename?: 'Inquiry';
  companyName?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
};

export type InquiryInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  authority: Authority;
  createdAt: Scalars['AWSTimestamp']['output'];
  email: Scalars['String']['output'];
  groups: Array<Group>;
  licenses: Array<LicenseData>;
};

export type InvitationBasicOutput = {
  __typename?: 'InvitationBasicOutput';
  authority?: Maybe<Array<Maybe<Authority>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  serviceSettings?: Maybe<Array<Maybe<ServiceSettings>>>;
};

export type InviteMultipleUserInput = {
  authority: AuthorityName;
  email: Array<Scalars['String']['input']>;
  groupIds: Array<Scalars['String']['input']>;
  licenseIds: Array<Scalars['String']['input']>;
};

export type InviteMultipleUsersInput = {
  inviteUsers: Array<InviteMultipleUserInput>;
};

export type InviteMultipleUsersOutput = {
  __typename?: 'InviteMultipleUsersOutput';
  error?: Maybe<Scalars['String']['output']>;
  failedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statusCode: Message;
};

export type InviteUserInput = {
  authority: AuthorityName;
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['String']['input']>;
  licenseIds: Array<Scalars['String']['input']>;
};

export type InviteUsersByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  inviteUsers: Array<InviteUserInput>;
};

export type InviteUsersInput = {
  inviteUsers: Array<InviteUserInput>;
};

export type InvitedUsers = {
  emails: Array<Scalars['String']['input']>;
};

export type License = {
  __typename?: 'License';
  assignmentCurrent?: Maybe<Scalars['Int']['output']>;
  assignmentLimit?: Maybe<Scalars['Int']['output']>;
  auth0OrganizationId: Scalars['String']['output'];
  master: LicenseMaster;
  planMaster?: Maybe<PlanMaster>;
};

export type LicenseData = {
  __typename?: 'LicenseData';
  roleId: Scalars['String']['output'];
  serviceId: ServiceId;
};

export type LicenseInput = {
  assignmentLimit: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  planMasterId?: InputMaybe<Scalars['ID']['input']>;
};

export type LicenseMaster = {
  __typename?: 'LicenseMaster';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serviceMaster: ServiceMaster;
  type: LicenseType;
};

export type LicenseQueryFilter = {
  licenseType?: InputMaybe<LicenseType>;
  planMasterId?: InputMaybe<Scalars['String']['input']>;
};

export const LicenseType = {
  organization: 'organization',
  user: 'user'
} as const;

export type LicenseType = typeof LicenseType[keyof typeof LicenseType];
export type LicenseValue = {
  __typename?: 'LicenseValue';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  usedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type LicenseValueInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ListOrganizationsOutput = {
  __typename?: 'ListOrganizationsOutput';
  auth0OrganizationId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  customerContactEmail: Scalars['String']['output'];
  customerContactName: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['String']['output'];
  maxGroups: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  planData?: Maybe<Array<Maybe<PlanData>>>;
  services?: Maybe<Array<Maybe<ServiceForListOrganizations>>>;
  specteeContactEmail: Scalars['String']['output'];
};

export const Message = {
  authorityLimitError: 'authorityLimitError',
  error: 'error',
  licenseLimitError: 'licenseLimitError',
  success: 'success'
} as const;

export type Message = typeof Message[keyof typeof Message];
export type Mutation = {
  __typename?: 'Mutation';
  activateUser: User;
  addRemoveMembersFromGroup: UpdateGroupResponse;
  createGroup: CreateGroupOutput;
  createGroupByAuth0OrganizationId: CreateGroupOutput;
  createLicensesByAuth0OrganizationId: Array<License>;
  createOptionEvent: Array<OptionEvent>;
  createOptions: Array<Option>;
  createOptionsByAuth0OrganizationId: Array<Option>;
  createOrganization: Organization;
  createPlanByAuth0OrganizationId: Plan;
  deleteAllUsers: DeleteAllUsersResponse;
  deleteGroups: DeleteGroupsResponse;
  deleteGroupsByAuth0OrganizationId: DeleteGroupsResponse;
  deleteInvitations: Array<Invitation>;
  deleteInvitationsByAuth0OrganizationId: Array<Invitation>;
  deleteOrganization: DeleteOrganizationResponse;
  deleteUsers: Array<User>;
  deleteUsersByAuth0OrganizationId: Array<User>;
  inviteMultipleUsers: InviteMultipleUsersOutput;
  inviteUsers: Array<Invitation>;
  inviteUsersByAuth0OrganizationId: Array<Invitation>;
  passwordReset?: Maybe<Scalars['String']['output']>;
  saveInquiry?: Maybe<Inquiry>;
  sendPasswordResetMail: Message;
  updateGroup: UpdateGroupResponse;
  updateGroupByAuth0OrganizationId: Group;
  updateLicenses: UpdateLicensesResponse;
  updateOrganizationByAuth0OrganizationId: UpdateOrganizationByAuth0OrganizationIdOutput;
  updateServicesByAuth0OrganizationId: Array<Service>;
  updateUser: User;
  updateUserByAuth0OrganizationId: User;
  updateUserDetails?: Maybe<UpdateResponse>;
  updateUserLatest: UpdateUserLatestOutput;
  updateUsers: Array<User>;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationAddRemoveMembersFromGroupArgs = {
  input: AddOrRemoveGroupInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupByAuth0OrganizationIdArgs = {
  input: CreateGroupByAuth0OrganizationIdInput;
};


export type MutationCreateLicensesByAuth0OrganizationIdArgs = {
  input: CreateLicensesByAuth0OrganizationIdInput;
};


export type MutationCreateOptionEventArgs = {
  input: CreateOptionEventInput;
};


export type MutationCreateOptionsArgs = {
  input: CreateOptionsInput;
};


export type MutationCreateOptionsByAuth0OrganizationIdArgs = {
  input: CreateOptionsByAuth0OrganizationIdInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePlanByAuth0OrganizationIdArgs = {
  input: CreatePlanByAuth0OrganizationIdInput;
};


export type MutationDeleteAllUsersArgs = {
  input: DeleteAllUsersInput;
};


export type MutationDeleteGroupsArgs = {
  input: DeleteGroupsInput;
};


export type MutationDeleteGroupsByAuth0OrganizationIdArgs = {
  input: DeleteGroupsByAuth0OrganizationIdInput;
};


export type MutationDeleteInvitationsArgs = {
  input: DeleteInvitationsInput;
};


export type MutationDeleteInvitationsByAuth0OrganizationIdArgs = {
  input: DeleteInvitationsByAuth0OrganizationIdInput;
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUsersArgs = {
  input: DeleteUsersInput;
};


export type MutationDeleteUsersByAuth0OrganizationIdArgs = {
  input: DeleteUsersByAuth0OrganizationIdInput;
};


export type MutationInviteMultipleUsersArgs = {
  input: InviteMultipleUsersInput;
};


export type MutationInviteUsersArgs = {
  input: InviteUsersInput;
};


export type MutationInviteUsersByAuth0OrganizationIdArgs = {
  input: InviteUsersByAuth0OrganizationIdInput;
};


export type MutationSaveInquiryArgs = {
  input: InquiryInput;
};


export type MutationSendPasswordResetMailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupByAuth0OrganizationIdArgs = {
  input: UpdateGroupByAuth0OrganizationIdInput;
};


export type MutationUpdateLicensesArgs = {
  input: UpdateLicensesInput;
};


export type MutationUpdateOrganizationByAuth0OrganizationIdArgs = {
  input: UpdateOrganizationByAuth0OrganizationIdInput;
};


export type MutationUpdateServicesByAuth0OrganizationIdArgs = {
  input: Array<UpdateServiceByAuth0OrganizationIdInput>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserByAuth0OrganizationIdArgs = {
  input: UpdateUserByAuth0OrganizationIdInput;
};


export type MutationUpdateUserDetailsArgs = {
  input: UserDetailsInput;
};


export type MutationUpdateUserLatestArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUsersArgs = {
  input: Array<UpdateUserInput>;
};

export type Option = {
  __typename?: 'Option';
  auth0OrganizationId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  masterId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  sortKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OptionEvent = {
  __typename?: 'OptionEvent';
  auth0OrganizationId: Scalars['String']['output'];
  contractType: ContractType;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  masterId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sortKey: Scalars['String']['output'];
};

export type OptionEventItem = {
  contractType: ContractType;
  endAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  masterId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type OptionMaster = {
  __typename?: 'OptionMaster';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenseId: Scalars['ID']['output'];
  licenseType: LicenseType;
  num?: Maybe<Scalars['Int']['output']>;
  planMasterId: Scalars['String']['output'];
};

export type OptionMasterQueryFilter = {
  licenseId?: InputMaybe<Scalars['String']['input']>;
  planMasterId?: InputMaybe<Scalars['String']['input']>;
};

export type OptionValue = {
  __typename?: 'OptionValue';
  checked: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  usedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type OptionValueInput = {
  checked: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  auth0OrganizationId: Scalars['ID']['output'];
  commonSettings?: Maybe<CommonSettings>;
  contractNumber: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  customerContactEmail: Scalars['String']['output'];
  customerContactName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maxGroups: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  planData?: Maybe<Array<Maybe<PlanData>>>;
  serviceSettings?: Maybe<Array<Maybe<ServiceSettings>>>;
  services?: Maybe<Array<Maybe<Service>>>;
  specteeContactEmail: Scalars['String']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  auth0OrganizationId: Scalars['ID']['output'];
  master: PlanMaster;
  status: PlanStatus;
};

export type PlanData = {
  __typename?: 'PlanData';
  serviceId: ServiceId;
  status: PlanStatus;
};

export type PlanDataInput = {
  serviceId: ServiceId;
  status: PlanStatus;
};

export type PlanMaster = {
  __typename?: 'PlanMaster';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenses: Array<PlanMasterLicense>;
  serviceMaster: ServiceMaster;
};

export type PlanMasterLicense = {
  __typename?: 'PlanMasterLicense';
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type PlanMasterQueryFilter = {
  serviceId?: InputMaybe<ServiceId>;
};

export const PlanStatus = {
  cancel: 'cancel',
  contract: 'contract',
  noContract: 'noContract',
  preContract: 'preContract',
  promotion: 'promotion',
  sales: 'sales',
  test: 'test',
  trial: 'trial'
} as const;

export type PlanStatus = typeof PlanStatus[keyof typeof PlanStatus];
export type Query = {
  __typename?: 'Query';
  getAdminData?: Maybe<AdminData>;
  getGroup?: Maybe<Group>;
  getInvitation?: Maybe<Invitation>;
  getInvitationBasicDetails?: Maybe<InvitationBasicOutput>;
  getInvitationBasicDetailsWithoutOrgId?: Maybe<InvitationBasicOutput>;
  getLicense?: Maybe<License>;
  getOrganization?: Maybe<Organization>;
  getOrganizationByAuth0OrganizationId?: Maybe<Organization>;
  getPlanMaster?: Maybe<PlanMaster>;
  getUser?: Maybe<User>;
  getUserByAuth0OrganizationId?: Maybe<User>;
  getUserDetails?: Maybe<UserDetails>;
  listAllUsers: Array<AllUsers>;
  listAuthorities: Array<Authority>;
  listGroups: Array<Group>;
  listGroupsByAuth0OrganizationId: Array<Group>;
  listInvitations: Array<Invitation>;
  listInvitationsByAuth0OrganizationId: Array<Invitation>;
  listLicenses: Array<License>;
  listLicensesByAuth0OrganizationId: Array<License>;
  listOptionMasters: Array<OptionMaster>;
  listOrganizations: Array<ListOrganizationsOutput>;
  listPlanMasters: Array<PlanMaster>;
  listPlans: Array<Plan>;
  listUsers: Array<User>;
  listUsersByAuth0OrganizationId: Array<User>;
};


export type QueryGetGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInvitationArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetInvitationBasicDetailsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetLicenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
};


export type QueryGetPlanMasterArgs = {
  planMasterId: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  auth0UserId: Scalars['ID']['input'];
};


export type QueryGetUserByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
  auth0UserId: Scalars['ID']['input'];
};


export type QueryListAllUsersArgs = {
  filter: InputMaybe<UserQueryFilter>;
};


export type QueryListGroupsByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
};


export type QueryListInvitationsByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
};


export type QueryListLicensesArgs = {
  filter: InputMaybe<LicenseQueryFilter>;
};


export type QueryListLicensesByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
};


export type QueryListOptionMastersArgs = {
  filter: InputMaybe<OptionMasterQueryFilter>;
};


export type QueryListPlanMastersArgs = {
  filter: InputMaybe<PlanMasterQueryFilter>;
};


export type QueryListUsersByAuth0OrganizationIdArgs = {
  auth0OrganizationId: Scalars['ID']['input'];
};

export type Service = {
  __typename?: 'Service';
  licenses: Array<License>;
  master: ServiceMaster;
  plan: Plan;
};

export type ServiceData = {
  __typename?: 'ServiceData';
  licenses: Array<LicenseValue>;
  serviceId: ServiceId;
};

export type ServiceForListOrganizations = {
  __typename?: 'ServiceForListOrganizations';
  master: ServiceMaster;
  status: PlanStatus;
};

export const ServiceId = {
  common: 'common',
  pro: 'pro',
  riskmonitor: 'riskmonitor',
  scr: 'scr',
  srm: 'srm'
} as const;

export type ServiceId = typeof ServiceId[keyof typeof ServiceId];
export type ServiceMaster = {
  __typename?: 'ServiceMaster';
  id: ServiceId;
  name: Scalars['String']['output'];
};

export type ServiceSettings = {
  __typename?: 'ServiceSettings';
  endDate?: Maybe<Scalars['String']['output']>;
  licenses: Array<LicenseValue>;
  options: Array<OptionValue>;
  serviceId: ServiceId;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type ServiceSettingsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  licenses: Array<LicenseValueInput>;
  options: Array<OptionValueInput>;
  serviceId: ServiceId;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateGroupResponse = {
  __typename?: 'UpdateGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  statusCode: Message;
};

export type UpdateLicenseItem = {
  assignmentLimit: Scalars['Int']['input'];
  licenseId: Scalars['String']['input'];
};

export type UpdateLicensesInput = {
  action: Action;
  activeUsers?: InputMaybe<ActiveUsers>;
  invitedUsers?: InputMaybe<InvitedUsers>;
  licenseId: Scalars['String']['input'];
};

export type UpdateLicensesResponse = {
  __typename?: 'UpdateLicensesResponse';
  error?: Maybe<Scalars['String']['output']>;
  statusCode: Message;
};

export type UpdateOrganizationByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  commonSettings?: InputMaybe<CommonSettingsInput>;
  planData?: InputMaybe<Array<InputMaybe<PlanDataInput>>>;
  serviceSettings?: InputMaybe<Array<InputMaybe<ServiceSettingsInput>>>;
  updateOrganizationItem: UpdateOrganizationItem;
};

export type UpdateOrganizationByAuth0OrganizationIdOutput = Organization | UserErrors;

export type UpdateOrganizationItem = {
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  customerContactEmail?: InputMaybe<Scalars['String']['input']>;
  customerContactName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  specteeContactEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResponse = {
  __typename?: 'UpdateResponse';
  statusCode: Scalars['Int']['output'];
};

export type UpdateServiceByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  serviceId: ServiceId;
  updateServiceItem: UpdateServiceItem;
};

export type UpdateServiceItem = {
  licenses: Array<InputMaybe<UpdateLicenseItem>>;
  planId: Scalars['ID']['input'];
  planStatus: PlanStatus;
};

export type UpdateUserByAuth0OrganizationIdInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  auth0UserId: Scalars['ID']['input'];
  updateItem: UpdateUserItem;
};

export type UpdateUserInput = {
  auth0UserId: Scalars['ID']['input'];
  updateItem: UpdateUserItem;
};

export type UpdateUserItem = {
  adminGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  authorityName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserLatestOutput = {
  __typename?: 'UpdateUserLatestOutput';
  error?: Maybe<Scalars['String']['output']>;
  statusCode: Message;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  adminGroupIds: Array<Scalars['String']['output']>;
  auth0UserId: Scalars['ID']['output'];
  authority: Authority;
  createdAt: Scalars['AWSTimestamp']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  groups: Array<Group>;
  licenseData?: Maybe<Array<Maybe<LicenseData>>>;
  licenses?: Maybe<Array<Maybe<LicenseMaster>>>;
  name: Scalars['String']['output'];
};

export type UserDetails = {
  __typename?: 'UserDetails';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type UserDetailsInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String']['output'];
};

export type UserErrors = {
  __typename?: 'UserErrors';
  userErrors: Array<UserError>;
};

export type UserQueryFilter = {
  groupId?: InputMaybe<FilterInput>;
  licenseId?: InputMaybe<FilterInput>;
  users?: InputMaybe<Users>;
};

export const Users = {
  active: 'ACTIVE',
  both: 'BOTH',
  invited: 'INVITED'
} as const;

export type Users = typeof Users[keyof typeof Users];
export type CreateOptionEventInput = {
  auth0OrganizationId: Scalars['ID']['input'];
  eventItems: Array<OptionEventItem>;
};

export const UserStatus = {
  active: 'active',
  expired: 'expired',
  invited: 'invited'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];